const state = {
  searchObj: {}, // 查询对象
  newAddress: {}, // 新增修改收货地址
  areaCode: [], // 当前区域编号
  currentPro: {}, // 当前商品
  userInfo: {
    account: '',
    headImage: ''
  }, // 当前用户信息
  platform:"",//平台 "b2b" "b2c"
  shoppingCart: {}, // 采购单列表
  cartNumber: '', // 采购单数量
  evaluateOrders: {}, // 评价订单
  noticeId: {}, // 公告id
  collectData: {}, // 店铺数据
  classify: [], //分类信息数据
  city_location: {label:'隆阳区',value:'BASE'},
  currentMenu: null,//帮助中心分类菜单
  articleList:[],//帮助中心文章
  componentContent:[],
  componentContentB2c:[],
  shopsData:{}
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js